import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, useNavigate } from 'react-router';
// import history from '../../history';
import {Translate, I18n} from 'react-redux-i18n';

import auth from '../../auth';
import Loading from '../../components/Loading/Loading';
import style from './Users.module.css';

import {
  fetchUsers as fetchUsersAction,
  fetchCompanies as fetchCompaniesAction,
  changeFilter as changeFilterAction,
  resetFilter as resetFilterAction,
} from './UsersActions';

function Users(props) {
  const {
    loading,
    users,
    companies,
    fetchUsers,
    fetchCompanies,
    resetFilter
  } = props;

  const navigate = useNavigate();

  const [filter, setFilter] = useState({
    name: '',
    company: '',
    limit: 25
  });

  useEffect(() => {
    fetchUsers();

    if (auth.can('user-master')) {
      fetchCompanies();
    }

    return () => {
      resetFilter();
    };
  }, [fetchUsers, fetchCompanies, resetFilter]);

  function createUser() {
    navigate('/user');
  }

  function changeFilter(e) {
    const newFilter = { ...filter, [e.target.id]: e.target.value };
    setFilter(newFilter);
  }

  function showMore(e) {
    e.preventDefault();
    setFilter(prev => ({ ...prev, limit: prev.limit + 25 }));
  }

  const { name, company } = filter;
  const isMaster = auth.can('exercise-master');
  const companiesObject = {};
  
  let filterNameUpCase = filter.name.toUpperCase();

  let filteredUsers = users.filter(user => {
      return ((user.name + user.user).toUpperCase().indexOf(filterNameUpCase) >= 0)
        && (!filter.company || user.company === filter.company);
  });

  let showShowMore = filter.limit < filteredUsers.length;
  filteredUsers = filteredUsers.slice(0, filter.limit);
  companies.forEach((cmp) => {
    companiesObject[cmp._id] = cmp.name;
  });

  return (
    <div className="row">
      <div className="col-md-12 mt-4">
        { loading && <Loading /> }
        <h3><strong><Translate value="users.title"/></strong></h3>
        <hr />
        <Translate value="users.desc"/><br/>
        <button className="btn btn-primary" onClick={createUser}>
          <i className="fas fa-plus" /> <Translate value="controls.Create"/>
        </button>
        { isMaster &&
          <div className={style.filterWrapper}>
            <p className={style.title}><Translate value="controls.Filters"/></p>
            <div className={style.filter}>
              <div className="d-flex">
                <div className="mb-3">
                  <label className="control-label" htmlFor="name"><Translate value="user.NameOrEmail"/></label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    value={name}
                    onChange={changeFilter}
                  />
                </div>
                <div className="mb-3">
                  <label className="control-label" htmlFor="name"><Translate value="user.Company"/></label>
                  <select
                    id="company" // This ID 'company' matches the key in filter state
                    value={company}
                    onChange={changeFilter}
                  >
                    <option value="">{ I18n.t('controls.All') }</option>
                    { (companies || []).map(cmp =>
                      <option value={cmp._id} key={cmp._id}>{cmp.name}</option>)
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
        }
        <table className="table table-striped table-condensed">
          <thead>
            <tr>
              <th><Translate value="user.Name"/></th>
              <th><Translate value="user.User"/></th>
              <th><Translate value="user.Company"/></th>
              <th><Translate value="user.UserLevel"/></th>
            </tr>
          </thead>
          <tbody>
            { filteredUsers.map((user) => {
              let userClass = 'fa-user';

              if (user.level === 'master') {
                userClass = 'fa-user-secret';
              } else if (user.level === 'admin') {
                userClass = 'fa-user-plus';
              }
            
              return (
                <tr key={user._id}>
                  <td><Link to={`/user/${user._id}`}><i className={`fas fa-fw ${userClass}`} /> {user.name}</Link></td>
                  <td>{user.user}</td>
                  <td>{companiesObject[user.company]}</td>
                  <td><Translate value={I18n.t("user.level." + user.level)}/></td>
                </tr>
              );
            })}
          </tbody>
        </table>
        { showShowMore ? <div className="text-center "><a href="#" onClick={showMore}>{ I18n.t('users.showMore') }</a></div> : null }
      </div>
    </div>
  );
}

Users.propTypes = {
  loading: PropTypes.bool,
  users: PropTypes.array,
  companies: PropTypes.array,
  filter: PropTypes.object,
  fetchUsers: PropTypes.func,
  fetchCompanies: PropTypes.func,
  changeFilter: PropTypes.func,
  resetFilter: PropTypes.func,
};

const mapStateToProps = state => ({
  loading: state.users.loading || state.users.loadingCompanies,
  users: state.users.data,
  filter: state.users.filter,
  companies: state.users.companies,
});

const mapDispatchToProps = {
  fetchUsers: fetchUsersAction,
  fetchCompanies: fetchCompaniesAction,
  changeFilter: changeFilterAction,
  resetFilter: resetFilterAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Users);
